import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="container">
        <style>
          {`
            .main-footer {
              padding: 20px 0;
              background-color :#242424;
            }

            .widgets-section {
              padding: 40px 0;
            }

            .footer-column {
              margin-bottom: 30px;
            }

            .footer-widget h2 {
              font-size: 18px;
              margin-bottom: 20px;
            }

            .footer-widget .list {
              list-style: none;
              padding: 0;
            }

            .footer-widget .list li {
              margin-bottom: 10px;
            }

            .footer-widget .list li a {
              color: #333;
              text-decoration: none;
            }

            .footer-widget .list li a:hover {
              text-decoration: underline;
            }

            .social-icons {
              // list-style: none;
              // padding: 0;
              // display: flex;
            }

            .social-icons li {
              margin-right: 10px;
            }

            .social-icons li a {
              color: #333;
              font-size: 16px;
            }

            @media (max-width: 768px) {
              .footer-column {
                width: 100%;
                margin-bottom: 20px;
              }

              .footer-widget .list li {
                margin-bottom: 5px;
              }

              .social-icons {
                justify-content: center;
              }
            }
          `}
        </style>
        <div className="widgets-section">
          <div className="row clearfix">
            {/* Column 1 - About Section */}
            <div className="big-column col-lg-12 col-md-12 col-sm-12">
              <div className="row clearfix">
                <div className="footer-column col-lg-4 col-md-6 col-sm-12">
                  <div className="footer-widget logo-widget">
                    <div className="logo pb-2">
                      <Link to="/">
                        <img
                          style={{ height: "14vh", width: "17vh" }}
                          src="/images/New_logo.png"
                          alt="Vamagems"
                          title="Vamagems"
                        />
                      </Link>
                    </div>
                    <ul className="social-icons">
                      <li style={{ marginRight: "2vh", paddingLeft: "3vh" }}>
                        <Link to="https://www.facebook.com/vamagemslimited?mibextid=ZbWKwL">
                          <span className="fab fa-facebook-f"></span>
                        </Link>
                      </li>
                      <li>
                        <Link to="https://www.instagram.com/vamajewelslimited?utm_source=qr&igsh=NGFveDRsdXB4eHps">
                          <span className="fab fa-instagram"></span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* Quick Links */}
                <div className="footer-column col-lg-4 col-md-12 col-sm-12">
                  <div
                    className="footer-widget links-widget"
                    style={{ color: "white" }}
                  >
                    <h2>Quick Links</h2>
                    <div className="widget-content">
                      <ul className="list">
                        <li>
                          <Link to="/about" style={{ color: "white" }}>
                            About
                          </Link>
                        </li>
                        <li>
                          <Link to="service" style={{ color: "white" }}>
                            Service
                          </Link>
                        </li>
                        <li>
                          <Link to="/contact" style={{ color: "white" }}>
                            Contact Us
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* Contact Info */}
                <div className="footer-column col-lg-4 col-md-6 col-sm-12">
                  <div className="footer-widget contact-widget">
                    <h2>Contact Info</h2>
                    <div className="widget-content">
                      
                      <ul
                        style={{
                          fontWeight: "bold",
                          padding: 0,
                          listStyle: "none",
                        }}
                      >
                       
                        <li
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            marginTop: "5px",
                          }}
                        >
                          <i className="fa-solid fa-phone"></i>
                          <Link
                            to="tel:+919920897971"
                            style={{ color: "white", textDecoration: "none" }}
                          >
                          +91 9920897971
                          </Link>
                        </li>
                        <li
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <i className="fa-solid fa-location-dot"></i>
                          {/* <span>  */}
                           Unit No. 38, Madhuban Ind Est,
                            <br /> Near Paper Box, MIDC, Andheri(East),
                            <br /> Mumbai - 400 093.
                          {/* </span> */}
                        </li>
                        <li
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            marginTop: "5px",
                          }}
                        >
                          <i className="fa-solid fa-envelope"></i>
                          <Link
                            to="mailto:vamajewelslimited@gmail.com"
                            style={{ color: "white", textDecoration: "none" }}
                          >
                            vamajewelslimited@gmail.com
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom Section with Developed By Info */}
        <div
          className="footer-bottom"
          style={{ textAlign: "center", color: "#fff" }}
        >
          <p>
            Developed & Designed By ||{" "}
            <a
              href="mailto:techsolution.check@outlook.in"
              style={{ color: "#fff" }}
            >
              techsolution.check@outlook.in
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;